export default {
  paymentSuccess: {
    event: "paymentSuccess",
    eventCategory: "Payment",
    eventAction: "Payment Button Click",
  },
  paymentFailure: {
    event: "paymentFailure",
    eventCategory: "Payment",
    eventAction: "Payment Button Click",
  },

  signUpView: {
    event: "signUp",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  registrationConfirmed: {
    event: "registrationConfirmed",
    eventCategory: "Registration",
    eventAction: "Registration Confirmed",
  },
  logInView: {
    event: "logIn",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  forgotpasswordview: {
    event: "forgotPassword",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  planView: {
    event: "plan",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  checkoutView: {
    event: "checkout",
    eventCategory: "Payment",
    eventAction: "Checkout Page View",
  },
  confirmationView: {
    event: "confirmation",
    eventCategory: "payment",
    eventAction: "Confirmation Page View",
  },
  quizView: {
    event: "quiz",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
};
